import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import { OrangeTextButton } from "../../common/OrangeTextButton";
import { useEditCameraStore } from "./editCameraStore/editCameraStore";

export const AddHealthMonitoringDialog = () => {
  const { addHealthMonitoringDialogOpen, setAddHealthMonitoringDialogOpen } =
    useEditCameraStore();
  return (
    <Dialog open={addHealthMonitoringDialogOpen} onClose={() => {}}>
      <DialogContent>
        <p className="font-mulish text-[18px] pt-[20px]">
          The site for this camera does currently not have camera health
          monitoring enabled.
        </p>
        <br></br>
        <p className="font-mulish text-[18px]">
          Note: If Camera Health Monitoring has not been previously enabled for
          this site, turning it on for this camera will enable it for{" "}
          <strong>all cameras</strong> on the site.
        </p>
        <br></br>
        <p className="font-mulish text-[18px]">
          Once health monitoring is enabled on all cameras you can disable it
          for each camera individually.
        </p>
      </DialogContent>
      <DialogActions>
        <OrangeTextButton
          onClick={() => {
            setAddHealthMonitoringDialogOpen(false);
          }}
          text="Ok"
          disabled={false}
        />
      </DialogActions>
    </Dialog>
  );
};
